module.exports = __webpack_public_path__ + "images/square-20-43fedba3372febbfc2901c5c65f7091a.jpg";